"use client";

import { AccessibilityAnchor } from "@faire/deprecated-retailer-visitor-shared/lib/AccessibilityLink";
import { getShouldShowImprintPageFromCountryAndLocale } from "@faire/deprecated-retailer-visitor-shared/lib/shouldShowImprintPage";
import { Core } from "@faire/design-tokens";
import { trackLoggedOutRetailersFooterLinksActionCategoryClick } from "@faire/web-api--source/events/loggedOutRetailers/actionCategoryClick/footerLinks";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";
import { Column, Flex, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

import { PaymentMethodIcons } from "../../PaymentMethodIcons";
import { useLinks } from "../LegalLinks";

export const LegalLinks: React.FC<{
  country: keyof typeof ISO3166Alpha3 | undefined;
  localeKey: ILocaleKey | undefined;
  adyenEUPaymentMethodsIcons: string[] | null;
}> = ({ country, localeKey, adyenEUPaymentMethodsIcons }) => {
  const links = useLinks(
    getShouldShowImprintPageFromCountryAndLocale(country, localeKey)
  );
  return (
    <Column justify="flex-start">
      {adyenEUPaymentMethodsIcons && adyenEUPaymentMethodsIcons.length > 0 ? (
        <>
          <Spacer size={{ mobileAndAbove: "3x", tabletAndAbove: 0 }} />
          <PaymentMethodIcons
            adyenEUPaymentMethodsIcons={adyenEUPaymentMethodsIcons}
          />
          <Spacer size={{ mobileAndAbove: "4x", tabletAndAbove: "2x" }} />
        </>
      ) : null}
      <Flex
        justify="flex-start"
        align="flex-start"
        className="w-full flex-wrap"
        direction={{ mobileAndAbove: "column", desktopAndAbove: "row" }}
      >
        <Typography variant="paragraphSansMedium">
          ©{new Date().getFullYear()} Faire Wholesale, Inc.
        </Typography>
        <Spacer size={{ mobileAndAbove: "2x", tabletAndAbove: "1x" }} />
        <Flex
          className="gap-3 md:gap-0"
          direction={{ mobileAndAbove: "column", tabletAndAbove: "row" }}
        >
          {links.map((item, index) => (
            <Row key={`${item.text}-${index}`}>
              <AccessibilityAnchor
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackLoggedOutRetailersFooterLinksActionCategoryClick(
                    item.link
                  )
                }
              >
                <Typography>{item.text}</Typography>
              </AccessibilityAnchor>
              {index + 1 === links.length ? null : (
                // no separator for last link
                <div className="hidden flex-row md:flex">
                  <Spacer size={4} />
                  <Typography color={Core.text.subdued}> • </Typography>
                  <Spacer size={4} />
                </div>
              )}
            </Row>
          ))}
        </Flex>
      </Flex>
    </Column>
  );
};
